import React from "react";
import './AboutUs.css';
export default function AboutUs() {
  return (
    <div  className="container about-outer">
     
      <div className="row about-section al-center">
         <div className="col-md-6">
         <h3 className=" about-sec-heading"> About us <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="100" height="100">
  
  <defs>
    <linearGradient id="arrowGradient" gradientTransform="rotate(45)">
      <stop offset="0%" stop-color="#63cec98a" />
      <stop offset="100%" stop-color="#eeb0f699" />
    </linearGradient>
  </defs>

 
  <g fill="none" stroke="url(#arrowGradient)" stroke-width="8" stroke-linecap="round" stroke-linejoin="round">
    
    <path d="M80,50 L60,30 L60,70 Z" />
   
    <path d="M60,50 L40,30 L40,70 Z" />
  </g>
</svg>


</h3>
<h2>Redefining Printing Excellence </h2>
            <p>At Printingy, we are committed to delivering top-tier printing solutions tailored to your unique needs. With expertise across industries like retail, education, hospitality, and corporate sectors, we specialise in creating high-quality prints that enhance your brand’s identity. From custom designs and premium materials to large-scale production and eco-friendly options, we ensure precision, creativity, and reliability in every project. We aim to help businesses communicate their message effectively through impactful and durable printing solutions. Partner with us for innovative, efficient, customised printing services that make your brand stand out.  </p>
            <br></br>
            <a class="cta-btn" href="/about">Read More</a>
         </div>
         <div className="col-md-6">
          <div className="about-img-container">
          <img className="about-img" src="/homeAbout.jpg" />
          </div>
        
         </div>
      </div>
    </div>
  );
}
